import { Molecule, wrap, today } from 'AppReact';
import styled from 'styled-components';
import { Icon, SecondaryTextSm } from 'atoms';
import { ClockSvg, StarSvg, RefreshArrowSvg, CalendarSvg } from 'components/icons';
import { FlexCenterWrapper, FlexCenterBetweenWrapper, Mr1, Mr2 } from 'wrappers';
import { differenceInDays, format, isToday, isValid } from 'date-fns';

const recurringDays = (order) => {
  let weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let wDays = order?.schedule?.wday;
  let day = order?.schedule?.day;
  let month = order?.schedule?.month;

  let newYearArray = month?.map((item, i) =>
    `${item}/${day[i]}`
  )

  let resultent = wDays?.map((item, i) => {
    return weekdays[item];
  });

  return wDays ? `Weekly on ${resultent.join(', ')} ` ?? '' : month ? `Yearly on ${newYearArray} ` ?? '' : `Monthly on ${day} ` ?? '';
}


const template = styled.div``;

export default Molecule({
  template,
  atoms: [
    {
      wrapper: FlexCenterBetweenWrapper,
      name: 'StatsWrapper',
      atoms: [
        {
          wrapper: FlexCenterWrapper,
          name: 'Stats',
          atoms: [
            {
              component: wrap(Icon, Mr2),
              name: 'ClockIcon',
              displayValue: ({ selectedTab }) => selectedTab !== 'recurring' ? ClockSvg({ width: '12', height: '12', color: window?.settings?.secondary_color ?? '#04333b' }) : RefreshArrowSvg({ width: '12', height: '12', color: window?.settings?.secondary_color ?? '#04333b' })
            },
            {
              component: SecondaryTextSm,
              name: 'Time',
              displayValue: ({ order, selectedTab }) => {
                let time = new Date(order?.inserted_at);
                let displayValue = '';
                let status = 'Submitted';

                if (selectedTab === 'assigned') {
                  time = new Date(order.assigned_at);
                  status = 'Assigned';
                }

                if (selectedTab === 'completed') {
                  time = new Date(order.completed_at);
                  status = 'Completed';
                }

                if (selectedTab === 'cancelled') {
                  time = new Date(order.cancelled_at);
                  status = 'Canceled';
                }

                if (selectedTab === 'recurring') {
                  time = recurringDays(order);
                  status = 'Recurs';
                  return `${status} ${time}`
                }

                if (!order.inserted_at) return '';

                if (!isValid(time)) return '';

                if (isToday(time)) {
                  displayValue = format(time, 'hh:mm a');
                  return `${status} ${displayValue}`
                }

                if (differenceInDays(today(), time) < 7) {
                  displayValue = format(time, 'EEEE');
                  return `${status} ${displayValue}`
                }

                displayValue = time ? format(time, 'MM/dd/yy') : '';
                return `${status} ${displayValue}`
              }
            }
          ]
        },
        {
          wrapper: FlexCenterWrapper,
          name: 'Scheduled',
          atoms: [
            {
              component: wrap(Icon, Mr1),
              name: 'Star',
              renderIf: ({ order }) => order.status === 'completed',
              displayValue: ({ }) => StarSvg({ width: '12', height: '12', filled: true, color: '#FFC700' })
            },
            {
              component: SecondaryTextSm,
              name: 'Scheduled',
              renderIf: ({ order }) => order.status === 'completed',
              displayValue: ({ order }) => `${order.rating ?? 0}`
            },
            {
              component: wrap(Icon, Mr2),
              name: 'ChatkIcon',
              renderIf: ({ order }) => ['unassigned', 'assigned'].includes(order.status) && order?.scheduled_for,
              displayValue: ({ }) => CalendarSvg({ bold: true, width: '12', height: '12', color: window?.settings?.secondary_color ?? '#04333b' })
            },
            {
              component: SecondaryTextSm,
              name: 'Scheduled',
              renderIf: ({ order }) => ['unassigned', 'assigned'].includes(order.status) && order?.scheduled_for,
              displayValue: ({ order }) => `Scheduled ${format(new Date(order.scheduled_for), 'MM/dd')}`
            }
          ]
        },
      ]
    },
  ],
})